// extracted by mini-css-extract-plugin
export default {"duration":"250ms","wrapper":"tdPIPp","enter":"IG9Jnh","enterActive":"l_1dOp","exit":"KuKbgp","exitActive":"g2iGHZ","is-drilled":"XYByTW","isDrilled":"XYByTW"};